import { render } from "./Reminders.vue?vue&type=template&id=4f0b798b&scoped=true&lang=pug"
import script from "./Reminders.vue?vue&type=script&lang=js"
export * from "./Reminders.vue?vue&type=script&lang=js"

import "./Reminders.vue?vue&type=style&index=0&id=4f0b798b&lang=scss&scoped=true"

import exportComponent from "/var/www/valley_watch_firm/fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0b798b"]])

export default __exports__